<template>
  <div class="history-page-wrapper">
    <loading-state :state="state"></loading-state>
    <div class="title-and-tools">
      <h2>Football View History</h2>
       <div v-if="Object.keys(variationHistory).length">
        <div v-for="history in variationHistory" :key="history.updated">
          <div class="box">
            <p>{{history.msg}} at {{history.updated | simpleDateTimeString}}</p>
          </div>
        </div>
      </div>
      <div v-else>
        <span class="warning-txt">Player Credit Points not yet edited for this match.</span>
      </div>
    </div>
  </div>
</template>

<script>
import { DataState } from '@/state'
import { CreditsHistory } from '@/models/workflow/cricket/fantasy'
export default {
  name: 'FootballViewHistory',
  data () {
    return {
      variationHistory: [],
      matchKey: this.$route.params.key,
      state: DataState.newLoading()
    }
  },
  mounted () {
    this.getCreditHistory()
  },
  methods: {
    getCreditHistory () {
      CreditsHistory.fetchCreditHistory(this.matchKey).then(history => {
        this.variationHistory = history
        this.state.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    }
  }
}
</script>
